import { Dialog } from './dialog';
import { Button } from "primereact/button";
import type { ReactNode } from 'react';

type GeneralInfoDialogProps = {
  visible: boolean;
  title?: string;
  message: string; // may contain HTML
  onClose: () => void;
  width?: string | number; // e.g. "500px" or 500
  parent?: HTMLDivElement | null;
  children?: ReactNode;
};

export function GeneralInfoDialog({
  visible,
  title = "Information",
  message,
  onClose,
  width,
  parent,
  children
}: GeneralInfoDialogProps) {

  let dialogWidth: string | number = width ?? 500;
  if (Number.isInteger(dialogWidth)) {
    dialogWidth = `${dialogWidth}px`;
  }
  return (
    <Dialog
      header={
        <div className="flex align-items-center gap-2">
          <i className="pi pi-info-circle text-primary text-xl" />
          <span className="font-semibold text-lg">{title}</span>
        </div>
      }
      visible={visible}
      onHide={onClose}
      modal
      appendTo={parent}
      style={{ width: dialogWidth, maxWidth: '95vw' }}
      contentStyle={{ maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}
    >
      <div className="flex flex-column gap-3" style={{ minHeight: 0, flex: '1 1 auto', overflow: 'hidden' }}>
        {children !== undefined ? <div className="text-color" style={{ lineHeight: 1.5, overflowY: 'auto', minHeight: 0, flex: '1 1 auto' }}>
          {children}
        </div> : <div
          className="text-color"
          style={{
            lineHeight: 1.5,
            overflowY: "auto",
            flex: "1 1 auto",
            minHeight: 0
          }}
          dangerouslySetInnerHTML={{ __html: message }}
        />}

        <div className="flex justify-content-end mt-3 pt-2 border-top-1 surface-border flex-shrink-0">
          <Button label="Close" icon="pi pi-times" className="p-button-text p-button-sm" onClick={onClose} />
        </div>
      </div>
    </Dialog>
  );
}
